import React, { PureComponent, createRef, Fragment } from "react";
import "./HorizontalBarChart.scss";
import { rawDataQuestion } from "../../global-interfaces";
import { select, scaleLinear, range, format, interpolateNumber } from "d3";
import { group } from "d3-array";
import Classnames from "classnames";
import { truncator } from "../../utils";

const pct_format: any = format(".0%");

interface Props {
  chart: rawDataQuestion;
  color: string | null;
  inView: boolean;
}

interface State {
  width: number | null;
}

class HorizontalBarChart extends PureComponent<Props, State> {
  private chartRef: React.RefObject<HTMLDivElement>;
  constructor(props: Props) {
    super(props);
    this.state = {
      width: 0,
    };
    this.chartRef = createRef();
    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.onResize();
    });
    this.onResize();
  }

  componentWillUnmount() {
    //@ts-ignore
    window.removeEventListener("resize"); // prevent memory leaks
  }

  onResize() {
    const width =
      this.chartRef.current &&
      this.chartRef.current.getBoundingClientRect().width;
    this.setState({
      width,
    });
  }

  componentDidUpdate(prevProps: Props) {
    const { data } = this.props.chart;
    select(this.chartRef.current)
      .selectAll(".label-data")
      .transition()
      .duration(500)
      .tween("html", function(_, j) {
        let old_value = prevProps.chart.data[j].value;
        let new_value = data[j].value;
        let that = select(this);
        let i = interpolateNumber(old_value, new_value);
        return function(t) {
          that.html(pct_format(i(t)));
        };
      });
  }

  render() {
    const { chart, color, inView } = this.props;
    const { data, chart_type } = chart;
    const { width } = this.state;

    const nestedData = Array.from(group(data, d => d.label_group));
    const xScale = scaleLinear()
      .domain([1, 0])
      .range([width || 0, 0]);

    return (
      <div
        className={Classnames("HorizontalBarChart", color)}
        ref={this.chartRef}
      >
        {nestedData.map((d: any, i) => (
          <Fragment key={i}>
            <div className={"label-group-div"}>
              <hr />
              <span className={"label-group"}>{d[0]}</span>
            </div>
            {d[1].map((d: any, i: any) => {
              const truncatedDiv =
                d.label.length >
                Math.abs(Math.floor(xScale(d.value) - 45)) / 9.2;
              return (
                <div key={i} className={Classnames("bar-group")}>
                  <div
                    className={Classnames("bar-dots")}
                    style={{
                      width: width || 0,
                    }}
                  >
                    {range(0, Math.floor((width || 0) / 20)).map(
                      (e: any, i: any) => (
                        <span key={"dot_" + i} className="dot" />
                      )
                    )}
                  </div>
                  <div
                    className={Classnames("bar-measure", chart_type, {
                      growOut: inView,
                      truncated: truncatedDiv,
                    })}
                    style={{
                      width: pct_format(d.value),
                    }}
                  >
                    <div className="label-measure">
                      <span className="measure">
                        {truncator(
                          d.label,
                          Math.abs(Math.floor(xScale(d.value) - 45)) / 9.2
                        )}
                      </span>
                      {truncatedDiv ? (
                        <span className="measure-hover">
                          {d.label} ({pct_format(d.value)})
                        </span>
                      ) : null}
                    </div>
                    <div className={"label-data"}>{pct_format(d.value)}</div>
                  </div>
                </div>
              );
            })}
          </Fragment>
        ))}
      </div>
    );
  }
}

export default HorizontalBarChart;
